import script from "./label.vue?vue&type=script&setup=true&lang=js"
export * from "./label.vue?vue&type=script&setup=true&lang=js"

import "./label.vue?vue&type=style&index=0&id=3bdd4be2&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bdd4be2"]])

export default __exports__